async function getBranding(token, host) {
  const url = `/nm-api/api/brand?host=${host}`;
  const headers = {
    "content-type": "application/json",
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  try {
    const res = await fetch(url, {
      headers,
      method: "GET",
      credentials: "include",
    });

    return await res.json();
  } catch (err) {
    return `Error: ${err}`;
  }
}
export default getBranding;
